export default __webpack_public_path__ + "static/media/excavator.290b8c46.jpg";